export default function ({ store, redirect }) {
  debugger
  if (store.state.drop.published) {
  } else {
    redirect('/404')
  }
}
